import { BarChartHeader } from './BarChartHeader';
import { BarChartRowContainer } from './BarChartRowContainer';
import { BarChartFooter } from './BarChartFooter';

export default function BarChart(props) {
  const chartData = props.data;

  let averageGlucose = 0,
    allGlucoseCount = 0;

  return (
    <div dir="rtl">
      <BarChartHeader />
      {chartData?.map((item, index) => {
        averageGlucose =
          averageGlucose + item.glucoseAverage * item.recordCount;
        allGlucoseCount = allGlucoseCount + item.recordCount;
        const barChartRowData = {
          index: index,
          hour: `${item.from}-${item.to} `,
          glucoseAverage: item.glucoseAverage,
          recordCount: item.recordCount,
          isHypo: item.glucoseAverage < 54 && item.recordCount !== 0,
          // for color of chart
          emptyRow:
            item.lowGlucoseCount +
              item.inRangeGlucoseCount +
              item.highGlucoseCount ===
            0,
          lowGlucoseWidth: (item.lowGlucoseCount * 100) / item.recordCount,
          inRangeGlucoseWidth:
            (item.inRangeGlucoseCount * 100) / item.recordCount,
          highGlucoseWidth: (item.highGlucoseCount * 100) / item.recordCount,
        };
        return (
          <BarChartRowContainer
            barChartRowData={barChartRowData}
          />
        );
      })}
      <BarChartFooter
        averageGlucose={averageGlucose}
        allGlucoseCount={allGlucoseCount}
      />
    </div>
  );
}
